module.exports = __webpack_public_path__ + "media/images/career_camp/2023/for_who_2-4f10fa52700e7dbfb1e8085cb7c82a3e.png";